export default function LoginReroute() {
    window.location.href = '/api/login';
}